import React from "react";
import { Box, Button, Text } from "grommet";

export const QuizContent = ({
  questions,
  currentQuestionIndex,
  selectedOption,
  setSelectedOption,
  handleNextQuestion,
  handlePreviousQuestion,
  isPaused,
  isLastQuestion,
  isFirstQuestion,
}) => {
  const currentQuestion = questions[currentQuestionIndex];

  return (
    <Box
      pad="medium"
      margin={{ horizontal: "large" }}
      background="light-1"
      round="medium"
    >
      <Text size="xlarge" weight="bold" margin={{ bottom: "medium" }}>
        {currentQuestion.question}
      </Text>
      <Box
        direction="row"
        gap="medium"
        justify="center"
        margin={{ top: "large" }}
      >
        {["Yes", "No"].map((option, index) => (
          <Box key={index} width="xsmall">
            <Button
              label={option}
              onClick={() => setSelectedOption(option)}
              disabled={isPaused}
              primary={selectedOption === option}
              color={selectedOption === option ? "accent-1" : "dark-3"}
              style={{
                borderRadius: "20px",
                padding: "8px 16px",
                fontSize: "20px",
                width: "100%",
              }}
              hoverIndicator={{
                background: {
                  color: selectedOption === option ? "accent-1" : "dark-3",
                  opacity: 0.8,
                },
              }}
            />
          </Box>
        ))}
      </Box>

      <Box
        direction="row"
        justify="between" // Ensures items are placed at opposite ends
        align="center"
        pad="small"
        margin={{ top: "medium" }}
      >
        {/* Left Section: "Your Answer" */}
        <Box
          width="50%" // Adjust width as needed
          pad={{ horizontal: "small", vertical: "xsmall" }}
          align="start"
        >
          <Text size="medium">Your answer:</Text>
          <Text weight="bold" color="brand" size="large">
            {selectedOption || "Please select an answer"}
          </Text>
        </Box>

        {/* Right Section: Buttons */}
        <Box direction="row" gap="small" align="end">
          {!isFirstQuestion && (
            <Button
              label={<Text color="white">Previous question</Text>}
              primary
              onClick={handlePreviousQuestion}
              size="large"
              disabled={isPaused}
              color="status-critical" // Change the button color (Grommet theme color)
              style={{
                borderRadius: "12px",
                padding: "12px 24px",
                fontSize: "18px",
              }}
            />
          )}
          <Button
            label={
              <Text color="white">
                {isLastQuestion ? "Submit my assessment" : "Next question"}
              </Text>
            }
            primary
            onClick={handleNextQuestion}
            size="large"
            disabled={isPaused}
            color="brand"
            style={{
              borderRadius: "12px",
              padding: "12px 24px",
              fontSize: "18px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
